import React from 'react';
import { Form, Input } from 'antd';

const FormItem = Form.Item;

const InputCustom = ({ label, name, placeholder, size, disabled, type, required, marginBottom="8", labelColor="85", className, onChange, ...rest}) => (
   <FormItem 
        label={label} 
        className={`form-label ${required ? 'required' : ''} margin-bottom${marginBottom} label-color${labelColor} ${className ? className : ''}`}
        >
       <Input 
            { ...rest }
            name={name}
            placeholder={placeholder} 
            className={`input ${disabled ? 'disabled' : ''}`} 
            size={size} 
            disabled={disabled}
            type={type}
            required={required}
            onChange={onChange} />
    </FormItem>
);

export default InputCustom;